import { PublicClientApplication } from '@azure/msal-browser'
import router from '../router'
import env_variables from '../../env_variables'

const config = {
  auth: {
    clientId: env_variables.clientId,
    authority: env_variables.authority,
    redirectUri: window.location.origin
  },
  cache: {
    cacheLocation: 'localStorage'
  }
}
const myMSALObj = new PublicClientApplication(config)

myMSALObj
  .handleRedirectPromise()
  .then(handleResponse)
  .catch(() => {
    alert('Error Logging Into Application')
  })

function handleResponse(response) {
  if (response !== null) {
    MSALInstance.userId = response.account.homeAccountId
  } else {
    const currentAccounts = myMSALObj.getAllAccounts()
    if (currentAccounts.length === 0) {
      return
    } else {
      MSALInstance.userId = currentAccounts[0].homeAccountId
    }
  }
}

const MSALInstance = {
  userId: null,
  msalConfig: myMSALObj,
  loginRequest: {
    scopes: [`${env_variables.clientId}/.default`],
  },
  login: function() {
    this.msalConfig.loginRedirect(this.loginRequest)
  },
  logout: function() {
    this.msalConfig.logoutRedirect({
      account: this.msalConfig.getAccountByUsername(this.userId),
      postLogoutRedirectUri: window.location.origin
    })
  },
  checkAuth: function() {
    return new Promise((resolve, reject) => {
      this.msalConfig
        .handleRedirectPromise()
        .then(res => {
          if (res !== null) {
            this.userId = res.account.homeAccountId
            resolve()
          } else {
            const currentAccounts = this.msalConfig.getAllAccounts()
            if (currentAccounts.length > 0) {
              this.userId = currentAccounts[0].homeAccountId
              resolve()
            } else {
              reject()
            }
          }
        })
        .catch(err => {
          reject(err)
        })
    })
  }
}

export const BasicAuth = {
  login: async function(userName, password) {
    return new Promise((resolve, reject) => {
      const code = btoa(`${userName}:${password}`)
      localStorage.setItem('BasicPasstoken', code)
      fetch('/api/v1/auth/principal', {
        headers: { Authorization: 'Basic ' + code },
        redirect: 'manual'
      })
        .then(res => {
          if (res.status === 200) {
            return router.push({ name: 'home' })
          } else if (
            res.status === 0 ||
            res.status === 302 ||
            res.status === 401
          ) {
            reject(Error('Invalid Login Details'))
          } else {
            reject(Error('Contact Administrator'))
          }
        })
        .catch(err => {
          return Error(err)
        })
    })
  },
  logout: function() {
    localStorage.removeItem('BasicPasstoken')
    router.push({ name: 'login' })
  },
  checkAuth: function() {
    return new Promise((resolve, reject) => {
      const code = localStorage.getItem('BasicPasstoken')
      if (!code) {
        reject(Error('No Token Found'))
        return
      }
      fetch('/api/v1/auth/principal', {
        headers: { Authorization: 'Basic ' + code },
        redirect: 'manual'
      })
        .then(res => {
          if (res.status === 200) {
            resolve()
          } else {
            reject(Error('Invalid Login Details'))
          }
        })
        .catch(err => {
          reject(Error(err))
        })
    })
  }
}

export default MSALInstance
